import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ToolStrip from "./components/ToolStrip";
import HotRanking from "./components/HotRanking";
import LatestGallery from "./components/LatestGallery";
import PackageZone from "./components/PackageZone";
import PersonIndex from "./components/PersonIndex";
import EventTimeline from "./components/EventTimeline";
import GuideSection from "./components/GuideSection";
import SubscribeForm from "./components/SubscribeForm";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  const [filter, setFilter] = useState("all");

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="w-full flex-1">
        <Hero />
        <ToolStrip active={filter} onChange={setFilter} />
        <HotRanking />
        <LatestGallery active={filter} />
        <PackageZone />
        <PersonIndex />
        <EventTimeline />
        <GuideSection />
        <SubscribeForm />
      </main>
      <SiteFooter />
    </div>
  );
}